import { isNil } from 'ramda';

import { isValidNumber } from '../../../utils/validators';
import { getNumberString } from './getNumberString';

export const isValidPrice = (value: string) => !isNil(value) && isValidNumber(getNumberString(value));
